"use client";

import { useEffect } from "react";
import useSearchListingPropertiesCount from "hooks/swr/useSearchListingPropertiesCount";
import { apiClientCommon } from "services/apiClientCommon";
export const RegisterIndexedPageInfoLogic = ({
  name,
  place_id,
  slug
}: {
  name: string;
  place_id: string;
  slug: string;
}) => {
  const countApiResponse = useSearchListingPropertiesCount();
  const count = countApiResponse?.data?.count || 0;
  useEffect(() => {
    if (count && count > 0) {
      void apiClientCommon.registerIndexedPageInfo({
        params: {
          name,
          place_id,
          url: slug
        }
      });
    }
  }, [name, place_id, slug, count]);
  return null;
};